module.exports = __webpack_public_path__ + "_assets/img/stamp.81cb4a2d.png";